import { useState, useCallback, useRef, useEffect } from 'react';
import { GripHorizontal } from 'lucide-react';

const DraggableModal = ({ children, className = '', onClose }) => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const isDragging = useRef(false);
  const dragStart = useRef({ x: 0, y: 0 });
  const modalRef = useRef(null);

  useEffect(() => {
    setPosition({ x: 0, y: 0 });
  }, []);

  const handleMouseDown = useCallback((e) => {
    if (e.target.closest('button, input, textarea, select, a, [role="button"]')) return;
    isDragging.current = true;
    dragStart.current = { x: e.clientX - position.x, y: e.clientY - position.y };
    document.body.style.userSelect = 'none';

    const handleMouseMove = (e) => {
      if (!isDragging.current) return;
      setPosition({
        x: e.clientX - dragStart.current.x,
        y: e.clientY - dragStart.current.y
      });
    };

    const handleMouseUp = () => {
      isDragging.current = false;
      document.body.style.userSelect = '';
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  }, [position]);

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" onClick={(e) => { if (e.target === e.currentTarget && onClose) onClose(); }}>
      <div
        ref={modalRef}
        className={className}
        style={{ transform: `translate(${position.x}px, ${position.y}px)`, position: 'relative', width: 'fit-content' }}
      >
        {/* Drag handle */}
        <div
          onMouseDown={handleMouseDown}
          className="absolute top-0 left-0 right-0 h-8 cursor-grab active:cursor-grabbing flex items-center justify-center z-10"
          title="Arrastra para mover"
        >
          <GripHorizontal className="w-5 h-5 text-muted-foreground/40" />
        </div>
        {children}
      </div>
    </div>
  );
};

export default DraggableModal;
